// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"a2pOnBoardStyles_modalWrapper__rMquW","modalInner":"a2pOnBoardStyles_modalInner__2kXuq"};